// API Configuration
export const API_CONFIG = {
  BASE_URL: 'https://dineiq.bizdocker.com/apis/public',
  //BASE_URL: 'http://127.0.0.1:8000',
  ENDPOINTS: {
    // Auth endpoints
    LOGIN: '/api/auth/login',
    REGISTER: '/api/auth/register',
    LOGOUT: '/api/auth/logout',
    ME: '/api/auth/me',
    
    // User endpoints
    USERS: '/api/users',
    USER_BY_ID: (id: number) => `/api/users/${id}`,
    USER_STATUS: (id: number) => `/api/users/${id}/status`,
    USER_SEARCH: '/api/users/search',
    USER_BY_ROLE: '/api/users/by-role',
    USER_BY_STATUS: '/api/users/by-status',
    ACTIVE_USERS: '/api/users/active',
    USER_DASHBOARD_STATS: '/api/users/dashboard-stats',
    
    // Role endpoints
    ROLES: '/api/roles',
    ROLE_BY_ID: (id: number) => `/api/roles/${id}`,
    ROLE_PERMISSIONS: (id: number) => `/api/roles/${id}/permissions`,
    
    // Permission endpoints
    PERMISSIONS: '/api/permissions',
    PERMISSION_BY_ID: (id: number) => `/api/permissions/${id}`,
    PERMISSIONS_BY_MODULE: (module: string) => `/api/permissions/module/${module}`,
    PERMISSION_MODULES: '/api/permissions/modules',
    
    // Customer endpoints
    CUSTOMERS: '/api/customers',
    CUSTOMER_BY_ID: (id: number) => `/api/customers/${id}`,
    
    // Supplier endpoints
    SUPPLIERS: '/api/suppliers',
    SUPPLIER_BY_ID: (id: number) => `/api/suppliers/${id}`,
    
    // Product endpoints
    PRODUCTS: '/api/products',
    PRODUCT_BY_ID: (id: number) => `/api/products/${id}`,
    
    // Order endpoints
    ORDERS: '/api/orders',
    ORDER_BY_ID: (id: number) => `/api/orders/${id}`,
    
    // Invoice endpoints
    INVOICES: '/api/invoices',
    INVOICE_BY_ID: (id: number) => `/api/invoices/${id}`,
    
    // Subscription endpoints
    SUBSCRIPTIONS: '/api/subscriptions',
    SUBSCRIPTION_BY_ID: (id: number) => `/api/subscriptions/${id}`,
    
    // Stock endpoints
    STOCK: '/api/stock',
    STOCK_BY_ID: (id: number) => `/api/stock/${id}`,
  }
};

// Helper function to get full API URL
export const getApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Helper function to get auth headers
export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  };
};

// Helper function to get auth headers for file uploads
export const getAuthHeadersForFileUpload = () => {
  const token = localStorage.getItem('token');
  return {
    'Authorization': `Bearer ${token}`,
  };
};
